let translations = {};
let queue = null;

import API from '../api'

export default class TranslationRegistry {
    /**
     * Store translation.
     *
     * @param key
     * @param value
     */
    static store(key, value) {
        if (typeof translations[key] === 'undefined') {
            clearTimeout(queue);
            queue = setTimeout(() => {
                TranslationRegistry.submit();
            }, 1000);
        }

        translations[key] = value;
    }

    /**
     * Submit translations to backend.
     */
    static submit() {
        if (window.environment && window.environment !== 'production') {
            if (!Object.keys(translations).length) {
                console.log('No translations available');
                return false;
            }

            console.log('Sending translations to backend: ', translations);

            API.storeTranslations({
                translations: JSON.stringify(translations)
            }).catch(err => {
                if (window.environment && window.environment === 'html') {
                    return;
                }

                console.error(err.response || err);
            });
        }
    }
}
